import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import BrowserLanguageDetector from 'i18next-browser-languagedetector';
import DynamicLocalizationLoader from 'i18next-http-backend';

const version = '18-09-2025';

i18next
  .use(initReactI18next)
  .use(BrowserLanguageDetector)
  .use(DynamicLocalizationLoader)
  .init({
    fallbackLng: 'en',
    backend: { loadPath: `/translations/{{lng}}.json?v=${version}` },
  });
